import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

let apiAbortController: AbortController | null = null;

const getAllTasks = async (
    limit: number = 50,
    skip: number = 0,
    filter?: Record<string, any>
) => {
    if (apiAbortController) {
        apiAbortController.abort();
    }

    // Create a new AbortController for the current request
    apiAbortController = new AbortController();
    try {
        const url = new URL(
            `${config.baseURL}/api/todo?limit=${limit}&skip=${skip}`
        );

        // Add filter parameters if provided (type, priority, etc.)
        if (filter) {
            console.log("API Filter applied:", filter);
            Object.entries(filter).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    url.searchParams.append(key, value.toString());
                    console.log(`Added filter: ${key}=${value}`);
                }
            });
        }

        console.log("Final API URL:", url.toString());

        const response = await AUTH_GET(url.toString(), {
            revalidate: 60,
            tags: ["dashboard", "all-tasks", `filter:${JSON.stringify(filter)}`, `limit:${limit}`, `skip:${skip}`],
            signal: apiAbortController?.signal,
        });
        apiAbortController = null; // Clear the controller after successful request
        return response;
    } catch (error: any) {
        console.log({ error });
        if (error.name === "AbortError") {
            // Handle fetch cancellation
            console.log("Fetch request canceled");
        } else {
            // Handle other errors
            throw error;
        }
    }
}

export default getAllTasks;